import { CampaignService } from '@fitness-force/api';
import type { Reports, SourceDataExtractionRules, EmailActionPayload, CampaignRequest, ReportDataForCampaign, ClientById, SendFreeFormEmailRequest, SendEmailTemplateRequest, AutomationMaster, Actions, ScheduleActionPayload, EmailTemplateMaster, STAFFINTERFACE, CampaignActionsGroup, AutomationActionPayload, NotificationError } from '@fitness-force/models';
import { NotificationService } from '@fitness-force/api';
import { NgClass, SlicePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit, OnDestroy, ChangeDetectorRef, SimpleChanges, OnChanges, input, output, inject, viewChild } from '@angular/core';
import { FormBuilder, FormsModule, ReactiveFormsModule, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { CommonService, TimeconversionService, ToastMessageService } from '@fitness-force/api';
import { AutomationEventType, CampaignSource, EmailSendType, OwnershipLevel, Roles, SendNotificationTo, StaffStatus, Status } from '@fitness-force/enum';
import type { EmailTemplateMasterById, REPORTSTOREINTERFACE } from '@fitness-force/models';
import type { EmailFromMaster } from '@fitness-force/models';
import { ButtonModule } from 'primeng/button';
import { DatePickerModule } from 'primeng/datepicker';

import { DialogModule } from 'primeng/dialog';
import { SelectModule } from 'primeng/select';
import { EditorModule } from 'primeng/editor';
import { FileUploadModule } from 'primeng/fileupload';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { InputTextModule } from 'primeng/inputtext';
import { BehaviorSubject, Observable, catchError, distinctUntilChanged, forkJoin, map, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ErrorMsgComponent } from '@fitness-force/errors';;
import { StyleClassModule } from 'primeng/styleclass';
import { AutomationScheduleTypeComponent } from '@fitness-force/shared';
import { FeatureFlagService } from '@fitness-force/shared-utils';
import { CheckboxModule } from 'primeng/checkbox';
import { Store } from '@ngrx/store';
import { STAFF_STATE } from '@fitness-force/state';
import { MultiSelectModule } from 'primeng/multiselect';
import { AvatarModule } from 'primeng/avatar';
import { SkeletonModule } from 'primeng/skeleton';
import { CORPORATE_CONFIG_DETAILS } from '@fitness-force/constants';
import { MessageModule } from 'primeng/message';

@Component({
  selector: 'send-bulk-email',
  templateUrl: './send-bulk-email.component.html',
  styleUrls: ['./send-bulk-email.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    DialogModule,
    ToggleSwitchModule,
    InputTextModule,
    DatePickerModule,
    SelectModule,
    EditorModule,
    ButtonModule,
    FileUploadModule,
    StyleClassModule,
    ErrorMsgComponent,
    AutomationScheduleTypeComponent,
    CheckboxModule,
    MultiSelectModule,
    AvatarModule,
    SkeletonModule,
    TranslateModule,
    MessageModule,
    NgClass,
    SlicePipe
]
})

export class SendBulkEmailComponent implements OnInit, OnChanges, OnDestroy {
  private notificationService = inject(NotificationService);
  private fb = inject(FormBuilder);
  private toastService = inject(ToastMessageService);
  private timeService = inject(TimeconversionService);
  private campaignsService = inject(CampaignService);
  private cd = inject(ChangeDetectorRef);
  private translateService = inject(TranslateService);
  private store = inject(Store);
  private commonService = inject(CommonService);
  private featureFlagService = inject(FeatureFlagService);

  readonly showPopup = input(false, { alias: "visible" });
  readonly assignedToStaffId = input(0, { alias: "staffId" });
  readonly tenantId = input(0);
  readonly franchiseId = input(0);
  readonly emailSendType = input<EmailSendType>(EmailSendType.FreeForm, { alias: "EmailSendType" });

  readonly columnData = input(new BehaviorSubject<any>([] as any[]));
  readonly CampaignSource = input<CampaignSource>(CampaignSource.Clients);
  readonly ReportDataForCampaign = input(new BehaviorSubject<ReportDataForCampaign>({} as ReportDataForCampaign)); 
  readonly totalRecords = input(new BehaviorSubject<number>(0));
  readonly selectedAllData = input(new BehaviorSubject<boolean>(false));
  readonly SelectedClient = input(new BehaviorSubject<ClientById>({} as ClientById)); 
  readonly actionPayload = input(new BehaviorSubject<EmailActionPayload>({} as EmailActionPayload)); 
  readonly automationMaster = input(new BehaviorSubject<AutomationMaster>({} as AutomationMaster));
  readonly formGroup = input<any>(new BehaviorSubject<any>(null));
  readonly uuid = input<string>("");
  readonly notificationTo = input<SendNotificationTo>(SendNotificationTo.Client);
  readonly ownership = input<OwnershipLevel>(OwnershipLevel.Tenant);
  readonly mode = input<string>("create");
  readonly scheduleInMin = input<number>(0);
  readonly closeSendEmailPopup = output<any>({ alias: 'closeSendEmailPopup' });
  readonly HidePopup = output<{
    closePopup: boolean;
    data: any | null;
    form: UntypedFormGroup | null;
    uuid: string;
    notificationTo: SendNotificationTo;
}>({ alias: 'hide' });
  readonly editor = viewChild<any>('editor');


  emailFrom: EmailFromMaster[]=[];
  emailTemplateMasters$ = new BehaviorSubject<EmailTemplateMaster[]>([] as EmailTemplateMaster[]);
  emailTemplateMaster$ = new BehaviorSubject<EmailTemplateMasterById | null>({} as EmailTemplateMasterById);
  sendEmailForm: UntypedFormGroup = new UntypedFormGroup({});
  selectedReport:REPORTSTOREINTERFACE = {} as REPORTSTOREINTERFACE;
  bodyreadOnly:boolean=false;
  btnLoading:boolean=false;
  automationTimingOptions:any;
  automationScheduleTypes:{ key: string; value: string; }[] =[];
  showCampaign = new BehaviorSubject<boolean>(false);
  accessedStaffs:STAFFINTERFACE[] =[];
  showScheduleType = new BehaviorSubject<boolean>(false);
  loading = true;
  private destroy$ = new Subject<void>();
  CorporateConfigDetails = CORPORATE_CONFIG_DETAILS;

  constructor() {

    this.sendEmailForm = this.fb.group({
      is_visible: [false, [Validators.required]],
      campaign_name: ['', []],
      campaign_action_date: [new Date(), []],
      campaign_description: ['', []],
      email_from: ['',[Validators.required]],
      source_date_extraction_rules: [],
      subject: ['',[Validators.required]],
      body: ['',[Validators.required]],
      email_template : [''],
      automation_timings_type : [''],
      automation_schedule_type : [''],
      automation_timing : [''],
      notify_record_associated_staff:[''],
      notify_additional_staff_to:[]
    });

   }

  ngOnInit(): void {
    // Check feature flag using getFlag$ for proper initialization
    this.featureFlagService.getFlag$('show_campaign')
      .pipe(takeUntil(this.destroy$))
      .subscribe(isEnabled => {
        this.showCampaign.next(isEnabled);
        this.cd.detectChanges();
      });
    
    this.componentInit();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  componentInit()
  {
    this.store.select(STAFF_STATE).subscribe((staffs: any) => {
      this.accessedStaffs = staffs.staffList.filter((s: STAFFINTERFACE) => 
      (s.role !== Roles.FFAdmin && s.role.toString() !== Roles[Roles.FFAdmin]) &&
      (s.status === StaffStatus.Active || s.status.toString() === StaffStatus[StaffStatus.Active])
    );
    });

    let forkArray: Observable<any>[] = [];
    const ownership = this.ownership();
    switch (ownership) {
      case OwnershipLevel.Company:
        forkArray = [
          this.notificationService.getEmailTemplatesByOwnership(ownership, 0, 0),
          this.notificationService.getSendEmailFromListByOwnership(ownership, 0, 0)
        ];
        break;

      case OwnershipLevel.Franchise:
        forkArray = [
          this.notificationService.getEmailTemplatesByOwnership(ownership, 0, this.franchiseId()),
          this.notificationService.getSendEmailFromListByOwnership(ownership, 0, this.franchiseId())
        ];
        break;

      case OwnershipLevel.Tenant:
        forkArray = [
          this.notificationService.getEmailTemplatesByOwnership(ownership, this.tenantId(), 0),
          this.notificationService.getSendEmailFromListByOwnership(ownership, this.tenantId(), 0)
        ];
        break;

      default:
        break;
    }

  forkJoin(forkArray).pipe(
    map(([emailTemplatesRes, sendEmailListRes]) => {
      const emailTemplates = emailTemplatesRes.items as EmailTemplateMaster[] || [];
      let sendEmailList = sendEmailListRes.items as EmailFromMaster[] || [];
      sendEmailList = sendEmailList.filter(o => o.status === true);

      let filteredEmailTemplates = emailTemplates.filter(o => o.status === Status.Active || o.status.toString() === Status[Status.Active]);
      
      const emailSendType = this.emailSendType();
      if (emailSendType === EmailSendType.Automation) {
        filteredEmailTemplates = filteredEmailTemplates.filter(o => {
          const automationMaster = this.automationMaster();
          return o.event_type == automationMaster.value.automation_type || o.event_type.toString() == AutomationEventType[automationMaster.value.automation_type];
        });
      } else if (emailSendType === EmailSendType.Campaign) {
        filteredEmailTemplates = filteredEmailTemplates.filter(o => o.event_type == AutomationEventType.Campaign || o.event_type.toString() == AutomationEventType[AutomationEventType.Campaign]);
      }
      
      this.emailTemplateMasters$.next(filteredEmailTemplates);
      sendEmailList.forEach(email => {
        if(this.CorporateConfigDetails['Emails'].includes(email.from_email))
        {
          email.isCorporate = true;
        }
        else{
          email.isCorporate = false;
        }
      });
      this.emailFrom = sendEmailList;
      this.SelectedEmailFromFormControl.setValue(sendEmailList.filter(o => o.isCorporate === false)[0]);
      
      const actionPayload = this.actionPayload();
      if (actionPayload && actionPayload.value) {
        this.setInitData();
      }
      else{
        this.showScheduleType.next(true);
      }
      this.loading = false;
      this.cd.detectChanges();
    }),
    catchError(error => {
      this.emailTemplateMasters$.next([]);
      this.emailFrom = [];
      this.loading = false;
      this.cd.detectChanges();
      return [];
    })
   ).subscribe();
    this.valueChangeFunction();
  }

  ngOnChanges(changes: SimpleChanges): void {
    // Handle changes to the formGroup input (edit mode)
    // Patch values into the existing form instance instead of replacing the reference,
    // to avoid breaking Angular's FormGroupDirective internal state.
    if (changes['formGroup'] && changes['formGroup'].currentValue?.value != null && changes['formGroup'].currentValue !== changes['formGroup'].previousValue)
    {
      const savedForm = changes['formGroup'].currentValue.value as UntypedFormGroup;
      this.sendEmailForm.patchValue(savedForm.value, { emitEvent: false });
      this.sendEmailForm.updateValueAndValidity();
    }
  }

  setInitData()
  {
    const actionPayload = this.actionPayload();
    if(actionPayload.value && actionPayload.value.email_from_config_id > 0)
       this.SelectedEmailFromFormControl.setValue(this.emailFrom.find(o => o.id == this.actionPayload().value.email_from_config_id))
    if(actionPayload.value && actionPayload.value.email_template_master_id &&
      actionPayload.value.email_template_master_id > 0)
      {
        this.SelectedEmailTemplateFormControl.setValue(this.emailTemplateMasters$.value.find(o => o.id == this.actionPayload().value.email_template_master_id));
        this.SelectEmailTemplate();
      }
    else {
        this.SubjectFormControl.setValue(actionPayload.value.subject);
        this.BodyFormControl.setValue(actionPayload.value.body);
     }

     const mode = this.mode();
     if(mode && mode =='update')
     {
      const scheduleType = this.scheduleInMin() > 0 ? 'After' : this.scheduleInMin() < 0 ?  'Before' : this.automationMaster().value.automation_timings[0].toString();
      const SelectedAutomationTimingType =  this.commonService.formatScheduleTime(this.scheduleInMin(),this.automationMaster().value.automation_type.toString());
      this.SelectedAutomationScheduleTypeFormControl.setValue({key:SelectedAutomationTimingType.key,value:SelectedAutomationTimingType.key});
      this.SelectedAutomationTimingTypeFormControl.setValue(scheduleType);
      this.sendEmailForm.controls['automation_timing'].setValue({key:SelectedAutomationTimingType.name,value:SelectedAutomationTimingType.value});
      this.sendEmailForm.updateValueAndValidity();
      this.cd.detectChanges();
     };
     this.showScheduleType.next(true);
  }

  valueChangeFunction() {
    this.IsVisibleFormControl.valueChanges
      .pipe(distinctUntilChanged())
      .subscribe((value: any) => {
        if (value) {
          this.CampaignNameFormControl.setValidators([Validators.required]);
          this.CampaignDescriptionFormControl.setValidators([Validators.required]);
          this.CampaignActionDateFormControl.setValidators([Validators.required]);
        } else {
          this.CampaignNameFormControl.removeValidators([Validators.required]);
          this.CampaignDescriptionFormControl.removeValidators([Validators.required]);
          this.CampaignActionDateFormControl.removeValidators([Validators.required]);
        }
      });

      this.SelectedEmailTemplateFormControl.valueChanges
      .pipe(distinctUntilChanged())
      .subscribe((value: any) => {
        if (value) {
          this.SubjectFormControl.disable();
          this.BodyFormControl.disable();
          this.bodyreadOnly=true;
        } else {
          this.SubjectFormControl.enable();
          this.BodyFormControl.enable();
          this.bodyreadOnly=false;
        }
      });
  }

  SelectEmailTemplate()
  {
    let service:any;
    const ownership = this.ownership();
    switch (ownership) {
      case OwnershipLevel.Company:
       service = this.notificationService.getEmailTemplateByIdWithOwnership(ownership,this.SelectedEmailTemplateFormControl.value.id,0,0);
        break;
      case OwnershipLevel.Franchise:
        service = this.notificationService.getEmailTemplateByIdWithOwnership(ownership,this.SelectedEmailTemplateFormControl.value.id,this.franchiseId(),0);
        break;
      case OwnershipLevel.Tenant:
        service = this.notificationService.getEmailTemplateByIdWithOwnership(ownership,this.SelectedEmailTemplateFormControl.value.id,0,this.tenantId());
        break;
      default:
        break;
    }
    service.subscribe({
      next: (res:EmailTemplateMasterById) => {
        this.emailTemplateMaster$.next(res);
        this.SubjectFormControl.setValue(res.subject_primary_language || res.subject_secondary_language);
        this.BodyFormControl.setValue(res.html_primary_language || res.html_secondary_language);
        if(res.preview_image_path) this.insertImage(res.preview_image_path);
        else this.insertText(res.html_primary_language || res.html_secondary_language);
      },
      error: (error:any) => {
        this.SelectedEmailTemplateFormControl.setValue(null);
        this.emailTemplateMaster$.next(null);
        this.SubjectFormControl.setValue(null);
        this.BodyFormControl.setValue(null);
      },
    });
  }

  getClientEmailsIds()
  {
    const emailSendType = this.emailSendType();
    if(emailSendType ==  EmailSendType.Bulk)
      return this.columnData().getValue().map((o: any) => o.clt_emailid);
    else if(emailSendType ==  EmailSendType.FreeForm)
      return [this.SelectedClient().value.email_id];
    else [];
  }

  getClientIds():any
  {
    const emailSendType = this.emailSendType();
    if(emailSendType ==  EmailSendType.Bulk)
      return this.filterUniqueNumbers(this.columnData().getValue().map((o: any) => parseInt(o.clt_id)));
    else if(emailSendType ==  EmailSendType.FreeForm)
      return [this.SelectedClient().value.id];
    else null;
  }


  SaveData()
  {
    if(this.sendEmailForm.valid)
    {
      this.btnLoading=true;
      const formValues = this.sendEmailForm.value;
      const emailActionPayload:EmailActionPayload = {} as EmailActionPayload;
      if(this.SelectedEmailTemplateFormControl.value)
      {
        emailActionPayload.email_template_master_id = this.SelectedEmailTemplateFormControl.value.id;
        emailActionPayload.email_from_config_id=this.SelectedEmailFromFormControl.value.id;
        emailActionPayload.body= this.BodyFormControl.value;
        emailActionPayload.subject= this.SubjectFormControl.value;
      }
      else{
        emailActionPayload.email_template_master_id=null;
        emailActionPayload.email_from_config_id=this.SelectedEmailFromFormControl.value.id;
        emailActionPayload.body= this.BodyFormControl.value;
        emailActionPayload.subject= this.SubjectFormControl.value;
      }
      if(this.emailSendType() == EmailSendType.Automation)
      {
        const actions : Actions= {} as Actions;
        const data :ScheduleActionPayload = {
          schedule_in_min: 0,
          actions: actions,
          action_name: "",
          associated_staff:false,
          staff_ids:[],
          description:""
        };
        data.schedule_in_min= this.SelectedAutomationTimingFormControl.value ? this.SelectedAutomationTimingFormControl.value.value : 0;
        data.action_name = this.SelectedAutomationTimingFormControl.value ?  this.SelectedAutomationTimingFormControl.value.key :  this.SelectedAutomationTimingTypeFormControl.value;
        data.associated_staff = this.SelectedAssociatedStaffFormControl && this.SelectedAssociatedStaffFormControl.value ? this.SelectedAssociatedStaffFormControl.value  : false ;
        data.staff_ids = this.SelectedAdditionalStaffFormControl && this.SelectedAdditionalStaffFormControl.value ? this.SelectedAdditionalStaffFormControl.value.map((staff: any) => staff.id) : [];
        data.actions.email_action_payload = emailActionPayload;
        data.actions.sms_action_payload = null;
        data.actions.whatsapp_action_payload = null;
        data.actions.task_action_payload = null;
        data.description = emailActionPayload.subject;
        console.log("automation data",data);
        this.closeSendEmailPopup.emit(true);
        this.HidePopup.emit({closePopup:true, data:data,form:this.sendEmailForm, uuid:this.uuid(), notificationTo:this.notificationTo()});
      }
      else{
        this.closeSendEmailPopup.emit(true);
        this.HidePopup.emit({closePopup:true, data:emailActionPayload, form:null, uuid:this.uuid(),notificationTo:this.notificationTo()});
      }
    }
    else {
      Object.keys(this.sendEmailForm.controls).forEach((field) => {
        const control = this.sendEmailForm.get(field);
        control?.markAsTouched({ onlySelf: true });
      });
      const firstElementWithError: Element | null = document.querySelector('.ng-invalid');
      if (firstElementWithError) firstElementWithError.scrollIntoView({ behavior: 'smooth' });
      this.btnLoading=false;
      this.cd.detectChanges();
    }
  }
  
  SendEmail()
  {
    if(this.sendEmailForm.valid)
    {
      this.btnLoading=true;
      const formValues = this.sendEmailForm.value;
      if(this.emailSendType() == EmailSendType.Bulk)
      {
        const payloadRequest : CampaignRequest[] = [] as CampaignRequest[];
        const payload : CampaignRequest = {} as CampaignRequest; 
        payload.campaign_name=formValues["campaign_name"];
        payload.campaign_isvisble=formValues["is_visible"];
        payload.campaign_description=formValues["campaign_description"];
        payload.tenant_id=this.tenantId();
        payload.campaign_ownership = OwnershipLevel.Tenant;
        payload.campaign_franchise = 0;
        payload.actions_group  = {} as CampaignActionsGroup;
        const actionGroups: CampaignActionsGroup = {} as CampaignActionsGroup;
        actionGroups.campaign_action_date = payload.campaign_isvisble ? this.timeService.ConvertLocalDateTimeToUTC(formValues["campaign_action_date"]) :  new Date().toISOString();
        actionGroups.source_data_type= this.CampaignSource();
        const sourceDataExtractionRules : SourceDataExtractionRules = {} as SourceDataExtractionRules;
        const CampaignSourceValue = this.CampaignSource();
        if(CampaignSourceValue == CampaignSource.Clients) {
          sourceDataExtractionRules.clients= this.getClientIds();
          sourceDataExtractionRules.reports=null;
          sourceDataExtractionRules.rule= null;
          sourceDataExtractionRules.jsonrule= null;
        }
        else if(CampaignSourceValue == CampaignSource.Report) {
          const reports : Reports ={} as Reports;
          const selectedReportData = this.ReportDataForCampaign().value;
          reports.payload = selectedReportData.rpt_fltr_payload;
          reports.relative_date = selectedReportData.rpt_fltr_relative_date_range;
          reports.report_key = selectedReportData.report_key;
          sourceDataExtractionRules.reports = reports;
          sourceDataExtractionRules.clients= null
          sourceDataExtractionRules.rule= null;
          sourceDataExtractionRules.jsonrule= null;
        }
        else{
          sourceDataExtractionRules.clients=null;
          sourceDataExtractionRules.reports=null;
          sourceDataExtractionRules.rule= null;
          sourceDataExtractionRules.jsonrule= null;
        }
        actionGroups.source_data_extraction_rules = sourceDataExtractionRules;
        actionGroups.action_payload = [] as AutomationActionPayload[];
        const actionPayloads: AutomationActionPayload = {
          actions: {
            client_email_action_payload: null,
            client_sms_action_payload: null,
            client_whatsapp_action_payload: null,
            staff_email_action_payload: null,
            staff_sms_action_payload: null,
            staff_whatsapp_action_payload: null,
            staff_task_action_payload: null,
            client_pushnotification_action_payload: null,
            staff_pushnotification_action_payload: null,
            notification_staff: null
          },
          schedule_in_min: 0
        };
        actionPayloads.actions.staff_sms_action_payload= null;
        actionPayloads.actions.client_sms_action_payload= null;
        actionPayloads.actions.staff_task_action_payload= null;
        actionPayloads.actions.staff_whatsapp_action_payload= null;
        actionPayloads.actions.client_whatsapp_action_payload= null;
        const emailActionPayload:EmailActionPayload = {} as EmailActionPayload;
        if(this.SelectedEmailTemplateFormControl.value)
        {
          emailActionPayload.email_template_master_id = this.SelectedEmailTemplateFormControl.value.id;
          emailActionPayload.email_from_config_id=this.SelectedEmailFromFormControl.value.id;
          emailActionPayload.body= this.BodyFormControl.value;
          emailActionPayload.subject= this.SubjectFormControl.value;
        }
        else{
          emailActionPayload.email_template_master_id=null;
          emailActionPayload.email_from_config_id=this.SelectedEmailFromFormControl.value.id;
          emailActionPayload.body= this.BodyFormControl.value;
          emailActionPayload.subject= this.SubjectFormControl.value;
        }
        actionPayloads.actions.client_email_action_payload= emailActionPayload;
        actionPayloads.actions.staff_email_action_payload= null;
        actionGroups.action_payload.push(actionPayloads);
        payload.actions_group= actionGroups;
        payloadRequest.push(payload);
        this.campaignsService.CreateCampaigns(payloadRequest).subscribe({
          next: (res) => {
            this.translateService.get('SEND_EMAIL.MSG.EMAIL_SEND')
              .subscribe((translation) => {
               this.toastService.showSuccess(translation);
              });
              this.btnLoading=false;
              this.cd.detectChanges();
              this.closePopupUp();
          },
          error: (error) => {
            if(error.originalError.status == 201)
            {
              this.translateService.get('SEND_EMAIL.MSG.EMAIL_SEND')
              .subscribe((translation) => {
              this.toastService.showSuccess(translation);
              });
              this.closePopupUp();
            }
            else{
              this.toastService.showError(error);
            }
            this.btnLoading=false;
            this.cd.detectChanges();
          },
        });
      }
      else{
        const freeFormPayload:SendFreeFormEmailRequest = {} as SendFreeFormEmailRequest;
        const templatePayload:SendEmailTemplateRequest = {} as SendEmailTemplateRequest;
        let service:any;
        if(this.SelectedEmailTemplateFormControl.value){
          templatePayload.body= this.BodyFormControl.value;
          templatePayload.email_from_config_id = this.SelectedEmailFromFormControl.value.id;
          templatePayload.email_template_master_id = this.SelectedEmailTemplateFormControl.value.id;
          templatePayload.subject = this.SubjectFormControl.value;
          service = this.notificationService.SendTemplatedEmail(this.tenantId(),this.getClientIds(),templatePayload);
        }
        else{
          freeFormPayload.base64 = "";
          freeFormPayload.bcc = [];
          freeFormPayload.body= this.BodyFormControl.value;
          freeFormPayload.email_from_config_id = this.SelectedEmailFromFormControl.value.id;
          freeFormPayload.to_email = this.getClientEmailsIds();
          freeFormPayload.file_extension = "";
          freeFormPayload.file_name = "";
          freeFormPayload.subject = this.SubjectFormControl.value;
          service = this.notificationService.SendFreeFormEmail(this.tenantId(),this.SelectedClient().value.id,freeFormPayload);
        }
        service.subscribe({
          next: (res:any) => {
            this.translateService.get('SEND_EMAIL.MSG.EMAIL_SEND')
              .subscribe((translation) => {
              this.toastService.showSuccess(translation);
              });
              this.btnLoading=false;
              this.cd.detectChanges();
              this.closePopupUp();
          },
          error: (error:any) => {
            if(error.originalError.status == 201)
            {
              this.translateService.get('SEND_EMAIL.MSG.EMAIL_SEND')
              .subscribe((translation) => {
              this.toastService.showSuccess(translation);
              });
              this.closePopupUp();
              this.cd.detectChanges();
            }
            else if(error.originalError.error &&  Array.isArray(error.originalError.error) && error.originalError.error.length>0)
              {
                error.originalError.error.forEach((element: NotificationError) => {
                  if(element.success)
                    {
                      this.translateService.get('SEND_EMAIL.MSG.EMAIL_SEND')
                      .subscribe((translation) => {
                        this.toastService.showSuccess(translation);
                      });
                    }
                    else
                    this.toastService.showErrorMessage(element.error.errorMessage);
      
                });
              }
            else{
              this.toastService.showError(error);
            }
            this.btnLoading=false;
            this.cd.detectChanges();
          },
        });
      }
    }
    else {
      Object.keys(this.sendEmailForm.controls).forEach((field) => {
        const control = this.sendEmailForm.get(field);
        control?.markAsTouched({ onlySelf: true });
      });
      const firstElementWithError: Element | null = document.querySelector('.ng-invalid');
      if (firstElementWithError) firstElementWithError.scrollIntoView({ behavior: 'smooth' });
      this.btnLoading=false;
      this.cd.detectChanges();
    }
  }

  getTomorrowDate(): string {
    const today = new Date();
    const tomorrow = new Date(today);
    tomorrow.setDate(today.getDate() + 1);
    const tomorrowDate = tomorrow.toISOString();
    return tomorrowDate;
  }

  filterUniqueNumbers(array: number[]): number[] {
    // Return unique numbers (deduplicate array)
    return Array.from(new Set(array));
  }

  closePopupUp()
  {
    this.closeSendEmailPopup.emit(true);
    this.HidePopup.emit({closePopup:true, data:null, form:null, uuid:this.uuid(),notificationTo:this.notificationTo()});
  }

  Updatevalue(event:any)
  {
    this.cd.detectChanges();
  }

  ngAfterViewInit() {
    this.removeQlImage();
  }
  
  removeQlImage() {
    const imgButton = document.getElementsByClassName('ql-image');
    for (let i = 0; i < imgButton.length; i++) {
      imgButton[i].remove();
    }
  
    const cleanButton = document.getElementsByClassName('ql-clean');
    for (let i = 0; i < cleanButton.length; i++) {
      cleanButton[i].remove();
    }
  
    const codeBlock = document.getElementsByClassName('ql-code-block');
    for (let i = 0; i < codeBlock.length; i++) {
      codeBlock[i].remove();
    }
    const linkButton = document.getElementsByClassName('ql-link');
    for (let i = 0; i < linkButton.length; i++) {
      linkButton[i].remove();
    }
  }

  insertImage(imageUrl:string) {
    const quill = this.editor().quill;
    const range = quill.getSelection();
    const position = range ? range.index : 0;
    quill.editor.insertEmbed(0, 'image', imageUrl, 'api');
    this.cd.detectChanges();
    //quill.editor.insertText(1, 'Hello', 'bold', true,'api');
  }

  insertText(text:string) {
    const quill = this.editor().quill;
    const range = quill.getSelection();
    const position = range ? range.index : 0;
    quill.editor.insertText(0, text ?? '');
    this.cd.detectChanges();
    //quill.editor.insertText(1, 'Hello', 'bold', true,'api');
  }

  public get isFormValid()
  {
    return this.sendEmailForm.valid;
  }

  get IsVisibleFormControl(): UntypedFormControl {
    return this.sendEmailForm.controls['is_visible'] as UntypedFormControl;
  }

  get CampaignNameFormControl(): UntypedFormControl {
    return this.sendEmailForm.controls['campaign_name'] as UntypedFormControl;
  }

  get CampaignDescriptionFormControl(): UntypedFormControl {
    return this.sendEmailForm.controls['campaign_description'] as UntypedFormControl;
  }

  get CampaignActionDateFormControl(): UntypedFormControl {
    return this.sendEmailForm.controls['campaign_action_date'] as UntypedFormControl;
  }

  get SubjectFormControl(): UntypedFormControl {
    return this.sendEmailForm.controls['subject'] as UntypedFormControl;
  }

  get BodyFormControl(): UntypedFormControl {
    return this.sendEmailForm.controls['body'] as UntypedFormControl;
  }

  get SelectedEmailTemplateFormControl(): UntypedFormControl {
    return this.sendEmailForm.controls['email_template'] as UntypedFormControl;
  }

  get SelectedEmailFromFormControl()
  {
    return this.sendEmailForm.controls['email_from'] as UntypedFormControl;
  }

  get SelectedAutomationTimingTypeFormControl()
  {
    return this.sendEmailForm.controls['automation_timings_type'] as UntypedFormControl;
  }

  get SelectedAutomationTimingFormControl()
  {
    return this.sendEmailForm.controls['automation_timing'] as UntypedFormControl;
  }

  get SelectedAutomationScheduleTypeFormControl()
  {
    return this.sendEmailForm.controls['automation_schedule_type'] as UntypedFormControl;
  }

  get SelectedAdditionalStaffFormControl()
  {
    return this.sendEmailForm.controls['notify_additional_staff_to'] as UntypedFormControl;
  }

  get SelectedAssociatedStaffFormControl()
  {
    return this.sendEmailForm.controls['notify_record_associated_staff'] as UntypedFormControl;
  }

  public get GetEmailSendType()
  {
    return EmailSendType;
  }

  public get SendNotificationTo()
  {
    return SendNotificationTo;
  }
}
